import { Button, Empty } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { pagingParamList } from '../../../contstant';
import { getValidSearchParams } from '../../../utils';

import styles from './index.module.scss';
import { useArticleContext } from '../Header/context';

interface NoDataProps {
  isSearchPage?: boolean;
}

export default function NoData({ isSearchPage = false }: NoDataProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { setFilters } = useArticleContext();

  return (
    // <Empty
    //   description={(
    //     <span className={styles.text}>
    //       Sorry, no data yet
    //       {/* <button
    //         className={styles.btn}
    //         type="button"
    //         onClick={(e) => {
    //           e.preventDefault();
    //           setSearchParams(getValidSearchParams(pagingParamList, searchParams));
    //         }}
    //       >
    //         clearing your filters
    //       </button> */}
    //     </span>
    //   )}
    // />
    <div className={styles.empty}>
      <div className={styles.emptyText}>
        <h3>
          {isSearchPage ? 'Sorry, no results matched your search terms' : 'Sorry, no data yet'}
        </h3>
        <div>
          {isSearchPage
            ? (
              <Button
                type="primary"
                className={styles.EmptyBtn}
                onClick={() => {
                  setFilters?.({
                    categoryId: [],
                    subCategoryId: [],
                    types: [],
                    tags: [],
                  });
                }}
              >
                Clear request
              </Button>
            )
            : null}
        </div>
      </div>
      <div className={styles.image}>
        <img src="/media/empty.png" alt="" />
      </div>
    </div>
  );
}
